import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function extractItemsFromSlider(sliderEl) {
    const item_list_name = sliderEl.dataset.itemListName || '';
    const item_list_id = sliderEl.dataset.itemListId || '';
    const items = [
        ...sliderEl.querySelectorAll('.tickets-slider__sliderItem'),
    ].map(card => ({
        item_id: card.dataset.id || '',
        item_name: card.dataset.name || '',
        item_brand: card.dataset.brand || '',
        item_category: card.dataset.category || '',
        item_category2: card.dataset.subcategory || '',
        item_category3: card.dataset.city || '',
        item_category4: card.dataset.venue || '',
        item_list_name,
        item_list_id,
    }));
    return { items, item_list_name, item_list_id };
}

function trackViewItemList(sliderEl) {
    const { items, item_list_name, item_list_id } =
        extractItemsFromSlider(sliderEl);
    if (items.length === 0) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            item_list_name,
            item_list_id,
            items,
        },
    });
}

function trackSelectItem(cardEl, sliderEl) {
    if (!cardEl || !sliderEl) return;
    const item_list_name = sliderEl.dataset.itemListName || '';
    const item_list_id = sliderEl.dataset.itemListId || '';
    const item = {
        item_id: cardEl.dataset.id || '',
        item_name: cardEl.dataset.name || '',
        item_brand: cardEl.dataset.brand || '',
        item_category: cardEl.dataset.category || '',
        item_category2: cardEl.dataset.subcategory || '',
        item_category3: cardEl.dataset.city || '',
        item_category4: cardEl.dataset.venue || '',
        item_list_name,
        item_list_id,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
            items: [item],
        },
    });
}

class TicketsSlider {
    constructor(el) {
        if (!this.set(el)) return;
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' &&
                !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }
    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-tickets-slider-slider]');
        this.prevEl = this.root.querySelector('[data-tickets-slider-prev]');
        this.nextEl = this.root.querySelector('[data-tickets-slider-next]');
        return true;
    }
    init() {
        this.initSlider();
        this.initGA4ViewItemListObserver();
        if (this.slider) {
            this.slider.addEventListener('click', e => {
                let target = e.target;
                while (target && !target.classList.contains('tickets-slider__sliderItem')) {
                    target = target.parentElement;
                }
                if (target && target.classList.contains('tickets-slider__sliderItem')) {
                    trackSelectItem(target, this.root);
                }
            });
        }
    }

    initGA4ViewItemListObserver() {
        if (!this.root) return;
        const observer = new window.IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!this._ga4ViewItemListSent) {
                            this._ga4ViewItemListSent = true;
                            if (typeof trackViewItemList === 'function') {
                                trackViewItemList(this.root);
                            }
                        }
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(this.root);
    }
    initSlider() {
        if (!this.slider) return;
        const swiperOptions = {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
        };
        if (this.nextEl && this.prevEl) {
            swiperOptions.navigation = {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            };
        }
        this.swiper = new Swiper(this.slider, swiperOptions);
    }
}

const initTicketsSliders = () => {
    const sections = document.querySelectorAll('[data-tickets-slider]');
    if (sections) sections.forEach(item => new TicketsSlider(item));
};

initTicketsSliders();
